module.exports = __webpack_public_path__ + "static/media/video_1.237ac88.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/video_1.mp4
// module id = cIf2
// module chunks = 0